import { Container, Row, Col } from "react-bootstrap";
import HealthcareLOGO1 from "../assets/img/HealthcareLOGO1.png";
import { Copyright } from "./Copyright";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="">
          <Col xs={12} md={6} xl={3}>
            <img
              style={{ marginBottom: "20px" }}
              className="imgfooter"
              src={HealthcareLOGO1}
              alt="Logo"
            />
            <p>We are here for you whenever you need Us!</p>
          </Col>
          <Col xs={12} md={6} xl={3}>
            <ul class="no-bullets">
              <li className="list-head">Fast Links</li>
              <li className="list-child">Services</li>
              <li className="list-child">Process</li>
              <li className="list-child">Departments</li>
              <li className="list-child">Contact Us</li>
            </ul>
          </Col>
          <Col xs={12} md={6} xl={3}>
            <ul class="no-bullets">
              <li className="list-head">Departments</li>
              <li className="list-child">Cancer (India Boasts)</li>
              <li className="list-child">Heart</li>
              <li className="list-child">Replacement</li>
              <li className="list-child">Cosmetic Surgery</li>
              <li className="list-child">Fertility (IVF)</li>
              <li className="list-child">Dental</li>
              <li className="list-child">Kidney Transplant</li>
              <li className="list-child">Spine</li>
              <li className="list-child">Eye Treatments</li>
            </ul>
          </Col>
          <Col xs={12} md={6} xl={3}>
            <ul class="no-bullets">
              <li className="list-head">Contact Info</li>
              <li className="list-child">Contact: +91 97******79</li>
              <li className="list-child">Email: jondoe@healthcare.com</li>
              <li className="list-child">
                Location: Andheri (East) , Mumbai, Maharashtra - 400057
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
      <Copyright />
    </footer>
  );
};
